window.addEventListener('SITE_START', () => {
  const $dropdowns = document.querySelectorAll('.dropdown[data-dropdown]');

  if (!$dropdowns.length) return;

  $dropdowns.forEach(($dropdown) => {
    const $button = $dropdown.querySelector('.dropdown__button');
    const $menu = $dropdown.querySelector('.dropdown__menu');

    if (!$button) return;

    $button.addEventListener('click', (e) => {
      e.stopPropagation();

      $dropdowns.forEach((other) => {
        if (other !== $dropdown) other.classList.remove('is-open');
      });

      $dropdown.classList.toggle('is-open');

      // 스크롤 가능하도록 이벤트 제어
      if ($dropdown.dataset.dropdown === 'basic' && $dropdown.classList.contains('is-open')) {
        if ($menu) {
          $menu.addEventListener('wheel', (e) => e.stopPropagation());
          $menu.addEventListener('touchmove', (e) => e.stopPropagation());
        }
      }
    });

    // basic dropdown
    if ($dropdown.dataset.dropdown === 'basic') {
      const $value = $dropdown.querySelector('.dropdown__value');
      const $options = $dropdown.querySelectorAll('.dropdown__option');
      $options.forEach(($option) => {
        $option.addEventListener('click', (e) => {
          if ($dropdown.dataset.linkable === 'true') return;
          e.stopPropagation();
          e.preventDefault();

          if ($value) {
            $value.textContent = $option.textContent;
            $value.setAttribute('data-value', $option.getAttribute('data-value'));
          }
          $dropdown.classList.remove('is-open');
        });
      });
    }
  });

  document.addEventListener('click', () => {
    $dropdowns.forEach(($dropdown) => $dropdown.classList.remove('is-open'));
  });
});
